<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknow">
<p class="ct"><a class="xref" href="#/pppsurvive0005#toc">Acknowledgments</a></p>
<p class="pf">I’d like to thank several animal management and zoo professionals for their invaluable advice on elephants and other topics included in this book. Mike Keele of Oregon Zoo generously helped with the basic plot, Dr. Jill Mellen contacted Dr. Eduardo Valdes who suggested a realistic study that would put Iris in the elephant barn, Surendra Varma of the Asian Elephant Research and Conservation Centre in Bangalore, South India, provided details of Asian elephant behavior. Penny Jolly, American Association of Zoo Keepers Board Member, kindly read through the manuscript and pointed out omissions, misstatements, and the like. Cynthia Cheney proofread the manuscript with not only her keen editorial eye, but also from the perspective of her years as a zoo keeper and as the publisher of <em>Penguin Conservation</em>. There were others as well whom I must acknowledge without naming, as they are weary from the conflicts over elephants that form part of the story within.</p>
<p>Thanks also to the Vancouver, Washington, Police Department for their assistance on police procedures and to an Assistant Special Agent in Charge with the U.S. Fish and Wildlife Service who asked to remain anonymous.</p>
<p>An author reserves the right to err regardless of the advice of experts as well as to bend reality to the service of fiction. I take full responsibility for any and all mistakes and improbabilities that reside within.</p>
<p>Several other writers were kind enough to review and comment constructively on drafts. I owe a considerable authorial debt to my writing group, Nancy LaPaglia, Evan (Dave) Lewis, Marilyn McFarlane, Angie Sanders, Doug Levin, and Christine Finlayson, as well as to Becky Kjelstrom and Elizabeth Voss. Thanks also to Phyllis Gonigam for naming Nimbus.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-survive0006.vue?1be4fefe